import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function AuthLoading() {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#f1f5f9',
      fontSize: '16px', color: '#64748b', fontFamily: "'Segoe UI', sans-serif",
    }}>
      Loading...
    </div>
  );
}

/**
 * AdminRoute — only admin can access.
 * A logged-in user is redirected to their own details page.
 */
export function AdminRoute({ children }) {
  const { role, userId, loading } = useAuth();

  if (loading) return <AuthLoading />;
  if (role === 'admin') return children;
  if (role === 'user' && userId) return <Navigate to={`/user/${userId}`} replace />;
  return <Navigate to="/" replace />;
}

/**
 * UserRoute — wraps /user/:id
 * Admin can view any user.
 * A regular user can only view their own page.
 */
export function UserRoute({ children }) {
  const { role, userId, loading } = useAuth();
  const { id } = useParams();

  if (loading) return <AuthLoading />;
  if (!role) return <Navigate to="/" replace />;
  if (role === 'admin') return children;
  if (role === 'user' && String(userId) === String(id)) return children;

  // User trying to access another user's page → bounce to own page
  if (role === 'user' && userId) return <Navigate to={`/user/${userId}`} replace />;
  return <Navigate to="/" replace />;
}
